<template>
  <div>
    <el-row class="grid-table">
      <el-form :inline="true" :model='data'>
        <el-form-item label="分类">
          <el-select v-model="search_data.examType">
            <el-option v-for="item in examTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="search" type="primary" @click='onSearch'>查询</el-button>
        </el-form-item>
      </el-form>
      <el-table stripe border style="width:100%;margin-top:10px" :data="table_data.data">
        <el-table-column prop="exam.examTitle" label="试卷标题"></el-table-column>
        <el-table-column prop="user.nickname" label="答卷人"></el-table-column>
        <el-table-column prop="startTime" label="开始答卷时间" :formatter="tableFormatter('dateFormat','startTime','yyyy-MM-dd hh:mm')"></el-table-column>
        <el-table-column prop="endTime" label="完成答卷时间" :formatter="tableFormatter('dateFormat','endTime','yyyy-MM-dd hh:mm')"></el-table-column>
        <el-table-column prop="exam.totalScores" label="参考总分"></el-table-column>
        <el-table-column prop="totalScores" label="最终得分"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{scope.row.isJudged ?　'已阅卷' : '未阅卷'}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.isJudged" type="primary" @click="goJudge(scope.row.objectId,scope.row.user.objectId)">开始阅卷</el-button>
            <el-button v-else @click="goDetail(scope.row.objectId,scope.row.user.objectId)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-size="search_data.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="table_data.total">
      </el-pagination>
    </el-row>
  </div>
</template>
<script type="text/javascript">
import utils from '@/utils/index'
import { tableFormatter } from "@/utils/formatter.js";
import common from '@/../server/common'
import '@/components/index'

export default {
  name: 'list',
  data () {
    return {
      tableFormatter,
      page_grade: common.page_grade,
      grade: {
        examJudge: !0
      },
      examTypes: common.examTypes,
      search_data: {
        examTitle: '',
        examType: 1,
        page: 1,
        pageSize: 10
      },
      table_data: {
        total: 0,
        data: []
      },
      loading: false,
    }
  },
  methods: {
    goDetail(id,userId){
      this.$router.push('/exam/recordDetail?recordId='+id+'&userId='+userId);
    },
    goJudge(id,userId){
      this.$router.push('/exam/judge?recordId='+id+'&userId='+userId);
    },
    // ajax请求列表数据
    ajaxData () {
      utils.ajax.call(this, '/judgeList', this.search_data, (obj, err) => {
        if (!err) {
          this.table_data.data = obj.list
          this.table_data.total = obj.total
          this.search_data.page = obj.page
        }
      })
    },
    // 点击查询
    onSearch () {
      this.search_data.page = 1
      this.ajaxData()
    },
    handleCurrentChange (page) {
      if (page !== this.search_data.page) {
        this.search_data.page = page
        this.ajaxData()
      }
    }
  },
  mounted () {
    this.ajaxData()
  },
  mixins: [common.mixin]
}
</script>
<style lang="less">
  .grid-table {
    .el-form-item {
      display: inline-block;
      max-height: 240px;
      width: ~'calc(24% - 10px)';
      &:first-child {
        .el-input {
          margin-right: 25px;
        }
      }
      &:last-child {
        overflow: hidden;
        white-space: nowrap;
        vertical-align: bottom;
      }
    }
    .el-pagination {
      margin-top: 5px;
      text-align: right;
    }
    .el-cascader--small .el-cascader__label {
      line-height: 40px;
    }
  }
</style>
